/* eslint-disable */
const modules = require
  .context('.', true, /js$/)
  .keys()
  .filter(path => !path.includes('index'))
  .map(path => path.replace(/(\.\/)|(\.js)/g, ''))
  .reduce((acc, key) => ({
    ...acc,
    [key]: require(`./${key}`).default,
  }), {})
/* eslint-enable */

export default Object.keys(modules).reduce((acc, moduleKey) => {
  const module = { ...modules[moduleKey] }

  if (!module.auto) {
    // raw store module
    module.auto = new Set()
  } else {
    Object.assign(module, {
      // external service name (someService)
      serviceName: moduleKey,

      // suffix for store actions (SOME_SERVICE)
      storeSuffix: moduleKey.split(/(?=[A-Z])/).join('_').toUpperCase(),
      lastFullFetch: 0,

      // internal store key (someService)
      storeKey: moduleKey,
      store: {},
    }, { ...module }, {
      auto: new Set(module.auto === '*'
        ? ['actions', 'getters', 'mutations', 'sync']
        : module.auto),
    })

    module.isClearable = module.auto.has('mutations') && module.isClearable !== false
  }

  acc[moduleKey] = module
  return acc
}, {})



// WEBPACK FOOTER //
// ./src/store/modules/index.js